// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions / selectors
import { setAxisExtremes } from './axis-extremes.action';
export const axisExtremes = createReducer({}, on(setAxisExtremes, (state, action) => action.axisExtremes));
